import { c as _c } from "react/compiler-runtime";
import styles from "./ExpandableTweetPreview.module.css";
export default function CompactControls(t0) {
  const $ = _c(9);
  const {
    showFade,
    showButton,
    isExpanded,
    onExpand
  } = t0;
  let t1;
  if ($[0] !== showFade) {
    t1 = showFade ? <div className={styles.fade} aria-hidden="true" /> : null;
    $[0] = showFade;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isExpanded || $[3] !== onExpand || $[4] !== showButton) {
    t2 = showButton ? <button type="button" className={styles.toggle} aria-expanded={isExpanded} onClick={onExpand}>Show full tweet</button> : null;
    $[2] = isExpanded;
    $[3] = onExpand;
    $[4] = showButton;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}